/** Normalize GET /fees/parent-accounts (legacy flat array or paginated envelope). */
export function parseParentAccountsResponse(data, fallbackPage = 1) {
  if (Array.isArray(data)) {
    return {
      accounts: data,
      meta: {
        total: data.length,
        page: 1,
        limit: data.length || 50,
        pages: 1,
      },
    };
  }

  if (data && typeof data === 'object') {
    const accounts = Array.isArray(data.accounts) ? data.accounts : [];
    const meta = data.meta ?? {
      total: accounts.length,
      page: fallbackPage,
      limit: 50,
      pages: accounts.length > 0 ? 1 : 0,
    };
    return { accounts, meta };
  }

  return {
    accounts: [],
    meta: { total: 0, page: fallbackPage, limit: 50, pages: 0 },
  };
}

/** Normalize GET /fees/parent-accounts/overdue-dues (legacy flat array or paginated envelope). */
export function parseOverdueDuesResponse(data, fallbackPage = 1) {
  if (Array.isArray(data)) {
    const overdueTotal = data.filter((row) => (row.status || 'Overdue') === 'Overdue').length;
    return {
      rows: data,
      meta: {
        total: data.length,
        page: 1,
        limit: data.length || 50,
        pages: 1,
        overdue_total: overdueTotal,
      },
    };
  }

  if (data && typeof data === 'object') {
    const rows = Array.isArray(data.rows) ? data.rows : [];
    const meta = data.meta ?? {
      total: rows.length,
      page: fallbackPage,
      limit: 50,
      pages: rows.length > 0 ? 1 : 0,
      overdue_total: rows.filter((row) => (row.status || 'Overdue') === 'Overdue').length,
    };
    return { rows, meta };
  }

  return {
    rows: [],
    meta: { total: 0, page: fallbackPage, limit: 50, pages: 0, overdue_total: 0 },
  };
}
